import { useSelector, useDispatch } from 'react-redux'
import { setUser, initialState } from 'store/auth/userSlice'
import { apiLogIn, apiLogOut } from 'services/AuthService'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import { useNavigate } from 'react-router-dom'
import { Success } from 'utils/alerts'

function useAuth() {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { token, refreshToken, signedIn } = useSelector(state => state.auth.session)
    const userInfo = useSelector(state => state.auth.user)
    const { permissionList } = useSelector(state => state.listData)

    const signIn = async values => {
        try {
            const resp = await apiLogIn(values)
            if (resp.data) {
                const { access, refresh } = resp.data.token
                const roles = Array.isArray(resp.data.role) ? resp.data.role : []
                const isBranchAdmin = roles.includes('branch_admin') || roles.includes('ADMIN')
                const branches = resp.data.branches || []
                
                if (isBranchAdmin && branches.length > 0) {
                    navigate(`/loyalty/cafes/${branches[0].id}`)
                } else {
                    navigate('/dashboard')
                }
                if (roles.includes('Customer') && roles.length === 1 && !resp.data.super_user) {
                    return {
                        status: 'failed',
                        message: 'You are not authorized',
                    }
                }
                dispatch(onSignInSuccess({ access: access, refresh: refresh }))
                if (resp.data) {
                    dispatch(
                        setUser({
                            avatar: '',
                            first_name: resp.data.first_name ?? 'User',
                            last_name: resp.data.last_name ?? '',
                            email: '',
                            super_user: resp.data.super_user,
                            user_id: resp.data.user_id,
                            role: resp.data.role,
                            permissions: resp.data.permissions ?? [],
                            branch: resp?.data?.branches?.map(item => item.id),
                            branches: resp?.data?.branches?.map(item => {
                                item.label = item.name
                                item.value = item.id
                                return item
                            }),
                        })
                    )
                }
                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: '',
            }
        }
    }

    const handleSignOut = () => {
        dispatch(onSignOutSuccess())
        dispatch(setUser(initialState))
        navigate('/login')
    }

    const signOut = async () => {
        apiLogOut({ refresh: refreshToken })
            .then(() => {
                Success('Logout successfully!')
                handleSignOut()
            })
            .catch(error => console.log('Error: ', error))
    }

    const checkPermission = (module, action) => {
        if (userInfo.super_user || module === 'dashboard') return true
        const roles = Array.isArray(userInfo.role) ? userInfo.role : []
        if (roles.includes('branch_admin')) {
            const forbiddenModules = ['companies', 'roles', 'assign-permissions']
            if (forbiddenModules.includes(module)) return false
            return true
        }
        let permissionsData = userInfo?.permissions ? [...userInfo?.permissions] : []
        const allPermissions = Object.keys(permissionList)
            .map(key => permissionList[key])
            .flat(Infinity)
        let status = false
        permissionsData = permissionsData.map(item => {
            const itemId = typeof item === 'object' ? item?.id : item
            return allPermissions.find(({ id }) => id === itemId)
        })
        permissionsData.map(item => {
            if (action) {
                if (module === item?.module && action === item?.action) {
                    status = true
                }
            } else {
                if (module === item?.module) {
                    status = true
                }
            }
            return item
        })

        return status
    }

    return {
        authenticated: token && signedIn,
        signIn,
        signOut,
        checkPermission,
    }
}

export default useAuth
